import apiClient from "../../helpers/apiClient"
import { createLoadingSelector } from "./Loading"

export const FETCH_EGIFT_CATALOG = "FETCH_EGIFT_CATALOG"
export const FETCH_EGIFT_CATALOG_REQUEST = "FETCH_EGIFT_CATALOG_REQUEST"
export const FETCH_EGIFT_CATALOG_SUCCESS = "FETCH_EGIFT_CATALOG_SUCCESS"
export const FETCH_EGIFT_CATALOG_FAILURE = "FETCH_EGIFT_CATALOG_FAILURE"

const initialState = {
	catalogCards: [],
	errorMessage: "",
	successMessage: "",
}

export const fetchingEgiftCatalogSelector = createLoadingSelector([FETCH_EGIFT_CATALOG])
export const fetchEgiftCatalog = () => (dispatch, getState) => {
	return dispatch({
		types: [
			FETCH_EGIFT_CATALOG_REQUEST,
			FETCH_EGIFT_CATALOG_SUCCESS,
			FETCH_EGIFT_CATALOG_FAILURE,
		],
		callAPI: (config) => apiClient.get(`api/Egift/GetCatalogs`, config),
		payload: {},
	})
}

export default function reducer(state = initialState, action) {
	const { payload, errorMessage, successMessage } = action
	switch (action.type) {
		case FETCH_EGIFT_CATALOG_REQUEST:
			return { ...state, errorMessage: "", successMessage: "" }
		case FETCH_EGIFT_CATALOG_SUCCESS:
			return { ...state, catalogCards: payload.itemLists, successMessage }
		case FETCH_EGIFT_CATALOG_FAILURE:
			return { ...state, errorMessage }
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/EgiftCardCatalog.js